export default (password: string): boolean => {
  const hasNumber = /\d/;
  
  return password.length >= 8 && hasNumber.test(password);
}